import { ShowGuesser} from "react-admin";

import FolderIcon from '@mui/icons-material/Folder';
import RubricList from "./RubricList";
import RubricEdit from "./RubricEdit";
import RubricCreate from "./RubricCreate";

const RubricResourceProps = {
    name: "rubric",
    list: RubricList,
    edit: RubricEdit,
    create: RubricCreate,
    show: ShowGuesser,
};

export const RubricMenuProps = {
    to: "/rubric",
    primaryText: "Rubrique",
    icon: FolderIcon,
};

export default RubricResourceProps;
